import React from "react";
import { JSX } from "react/jsx-runtime";

const PaginationNextIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <ellipse cx="10.5" cy="10.5" rx="10.5" ry="10.5" transform="rotate(-180 10.5 10.5)" fill="#202020" fill-opacity="0.1"/>
        <line y1="-0.5" x2="5.87845" y2="-0.5" transform="matrix(0.680451 0.732793 -0.680451 0.732793 6 7)" stroke="black"/>
        <line y1="-0.5" x2="5.65685" y2="-0.5" transform="matrix(-0.707107 0.707107 -0.653016 -0.757344 10 10)" stroke="black"/>
        <line y1="-0.5" x2="5.87845" y2="-0.5" transform="matrix(0.680451 0.732793 -0.680451 0.732793 10 7)" stroke="black"/>
        <line y1="-0.5" x2="5.65685" y2="-0.5" transform="matrix(-0.707107 0.707107 -0.653016 -0.757344 14 10)" stroke="black"/>
    </svg>

  );
};

export default PaginationNextIcon;


